// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedV5",
    "DevelopmentProject",
    "DevelopmentProjectSampleUnit",
    "ForSalePropertyV5",
    "MessageBroadcast",
    "RentalNeedV5",
    "RentalPropertyV5"
  ]);
}

function unwrap_fragment_ForSalePropertyV5_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AnonymousForSalePropertyAgent",
    "VisibleForSalePropertyAgent"
  ]);
}

let fragmentConverter = {"__root":{"RentalPropertyV5_agent":{"f":""},"RentalNeedV5_agent":{"f":""},"MessageBroadcast_agent":{"f":""},"ForSalePropertyV5_agentV2_VisibleForSalePropertyAgent_agent":{"f":""},"ForSalePropertyV5_agentV2":{"u":"fragment_ForSalePropertyV5_agentV2"},"DevelopmentProject_agent":{"f":""},"DevelopmentProjectSampleUnit_agent":{"f":""},"BuyerNeedV5_agent":{"f":""},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment_ForSalePropertyV5_agentV2: unwrap_fragment_ForSalePropertyV5_agentV2,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Agent",
    "kind": "LinkedField",
    "name": "agent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AgentProfilePhoto_agent"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageNewConversationByType_conversationContext",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "BuyerNeedV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "agentV2",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "AnonymousForSalePropertyAgent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "VisibleForSalePropertyAgent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ForSalePropertyV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "MessageBroadcast",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "RentalNeedV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "RentalPropertyV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "DevelopmentProject",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "DevelopmentProjectSampleUnit",
      "abstractKey": null
    }
  ],
  "type": "ConversationContextV5",
  "abstractKey": "__isConversationContextV5"
};
})());

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_ForSalePropertyV5_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_ForSalePropertyV5_agentV2 = unwrap_fragment_ForSalePropertyV5_agentV2;
exports.wrap_fragment_ForSalePropertyV5_agentV2 = wrap_fragment_ForSalePropertyV5_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
